exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-tag + .el-tag[data-v-7e7e1b87] {\n  margin-left: 10px;\n}\n", ""]);

// exports
